import { render, staticRenderFns, recyclableRender, components } from "./u-number-box.vue?vue&type=template&id=6cbf39ee&scoped=true&"
var renderjs
import script from "./u-number-box.vue?vue&type=script&lang=js&"
export * from "./u-number-box.vue?vue&type=script&lang=js&"
import style0 from "./u-number-box.vue?vue&type=style&index=0&id=6cbf39ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf39ee",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-number-box/u-number-box.vue"
export default component.exports